import { getRgObjectsOfType as s, RG_TYPE as i } from "@project-rouge/rg-core";
const m = (e) => {
  const t = {}, o = s(e, i.Apartment);
  for (const n of o) {
    const a = n.name;
    t[a] || (t[a] = { count: 0, nia: 0 }), t[a].count++, t[a].nia += n.data.nia;
  }
  const r = Object.keys(t), c = o.length;
  return r.map((n) => ({
    name: n,
    count: t[n].count,
    averageNia: t[n].nia / t[n].count,
    ratio: t[n].count / c
  }));
};
export {
  m as getApartmentTypeCounts
};
//# sourceMappingURL=index2.js.map
